// Module
var code = "<script>let $ctrl</script> <div class=\"atom-chart-bar {{ $ctrl.setModifier($ctrl.reachedPercentage) }}\" ng-attr-title=\"{{ $ctrl.reachedPercentage }}%\"> <div class=\"atom-chart-bar__rect\" ng-style=\"{ 'width': $ctrl.reachedPercentage + '%' }\"></div> </div> ";
// Exports
module.exports = code;